import React from "react";
import moment from "moment";
import PropTypes from 'prop-types';
import {
  Page,
  View,
  Text,
  Font,
  Document,
  StyleSheet
} from '@react-pdf/renderer';
import { formatCurrency } from "../../../util/formatCurrency";

Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/fonts/Roboto-Regular.ttf' },
    { src: '/fonts/Roboto-Bold.ttf' }
  ]
});

const styles = StyleSheet.create({
  subtitle2: { fontSize: 9, fontWeight: 700 },
  alignRight: { textAlign: 'right' },
  page: {
    padding: '40px 24px 0 24px',
    fontSize: 9,
    lineHeight: 1.6,
    fontFamily: 'Roboto',
    backgroundColor: '#fff',
    textTransform: 'capitalize'
  },

  table: { display: 'flex', width: 'auto', 
  boxShadow:"0 2px 4px 0 #cbd4da", 
borderBottomWidth: 1,
borderStyle: 'solid',
borderColor: '#DFE3E8',
  borderRadius: "3px" },
  tableHeader: {
      backgroundColor: "#cbd4da"
  },
  tableBody: {},
  tableRow: {
    padding: '8px 0',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: '#DFE3E8'
  },
  tableCell_1: { padding: 2, width: '10%' },
  tableCell_2: { padding: 2, width: '50%', paddingRight: 16 },
  tableCell_3: { padding: 2, width: '15%' }
});

AwardedContractPDF.propTypes = {
    contracts: PropTypes.array
};

export default function AwardedContractPDF({ contracts = [] }) {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <View style={styles.tableRow}>
              <View style={styles.tableCell_1}>
                <Text style={styles.subtitle2}>OCID</Text>
              </View>
              <View style={styles.tableCell_3}>
                <Text style={styles.subtitle2}>Project Title</Text>
              </View>
              
              <View style={styles.tableCell_3}>
                <Text style={styles.subtitle2}>Budget Desc</Text>
              </View>
              <View style={styles.tableCell_3}>
                <Text style={styles.subtitle2}>Ministry</Text>
              </View>
              <View style={styles.tableCell_1}>
                <Text style={styles.subtitle2}>Category</Text>
              </View>


              <View style={styles.tableCell_3}>
                <Text style={styles.subtitle2}>Contractor</Text>
              </View>      
              <View style={styles.tableCell_1}>
                <Text style={styles.subtitle2}>Start date</Text>
              </View>      
              <View style={styles.tableCell_1}>
                <Text style={styles.subtitle2}>End date</Text>
              </View>
              <View style={[styles.tableCell_1, styles.alignRight]}>
                <Text style={styles.subtitle2}>Value</Text>
              </View>
            </View>
          </View>

          <View style={styles.tableBody}>
            {contracts.map((contract) => {
                return (
              <View style={styles.tableRow} key={contract.id}>
                <View style={styles.tableCell_1}>
                  <Text>{contract.referenceId}</Text>
                </View>
                <View style={styles.tableCell_3}>
                  <Text style={styles.subtitle2}>{contract.title}</Text>
                </View>
                <View style={styles.tableCell_3}>
                  <Text>{contract.budgetDescription}</Text>
                </View>
                <View style={styles.tableCell_3}>
                  <Text>{contract?.procurement?.ministry?.name}</Text>
                </View>

                <View style={styles.tableCell_1}>
                  <Text>{contract.procurement?.category?.name}</Text>
                </View>
                <View style={styles.tableCell_3}>
                  <Text>{contract.vendor}</Text>
                </View>
                <View style={styles.tableCell_1}>
                  <Text>{moment(contract.startDate || contract.dateAwarded).format("DD MMM, YYYY")}</Text>
                </View>
                <View style={styles.tableCell_1}>
                  <Text>{moment(contract.endDate || contract.expiryDate).format("DD MMM, YYYY")}</Text>
                </View>



                <View style={[styles.tableCell_1, styles.alignRight]}>
                  <Text>NGN{formatCurrency(contract?.estimatedValue)}</Text>
                </View>
              </View>
            )})}
          </View>
        </View>
      </Page>
    </Document>
  );
}
